export const ADDRESS_BOOK_PAGE_ALIAS = 'address-book';
export const ADDRESS_MANAGEMENT_PAGE_ALIAS_LIST = [
  'create-address',
  'edit-address',
];

export const enum NOTIFICATIONS {
  addressAdded = 'PAGES.ACCOUNT.ADDRESS_BOOK.ADDRESS_ADDED_MESSAGE',
  addressSaved = 'PAGES.ACCOUNT.ADDRESS_BOOK.ADDRESS_SAVED_MESSAGE',
  addressSavedWithoutChanges = 'PAGES.ACCOUNT.ADDRESS_BOOK.ADDRESS_WITHOUT_CHANGES_MESSAGE',
  addressRemoved = 'PAGES.ACCOUNT.ADDRESS_BOOK.ADDRESS_REMOVED_MESSAGE',
}

export const ADDRESS_DELETE_DISABLED = 'address_deletion_disabled';
